module.exports = __webpack_public_path__ + "img/photoAlbum1.55baab5c.jpg";